/**
 * Lightweight GA4 event tracking wrapper.
 * Safe to call anywhere — silently no-ops if gtag is not loaded.
 */

/* eslint-disable @typescript-eslint/no-explicit-any */
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

/**
 * Send a GA4 custom event.
 * @param name Event name (use snake_case per GA4 convention)
 * @param params Optional event parameters
 */
export function trackEvent(name: string, params?: Record<string, unknown>) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', name, params);
  }
}

/**
 * Send a GA4 page_view manually. Useful for SPA navigation.
 * @param pagePath Page path, e.g. '/formatter/json-formatter/'
 * @param pageTitle Page title
 * @param pageLang Language code, e.g. 'en' | 'zh'
 */
export function trackPageView(pagePath: string, pageTitle?: string, pageLang?: string) {
  if (typeof window !== 'undefined' && window.gtag) {
    const params: Record<string, unknown> = {
      page_path: pagePath,
      send_page_view: true,
    };
    if (pageTitle) params.page_title = pageTitle;
    if (pageLang) params.language = pageLang;
    window.gtag('event', 'page_view', params);
  }
}
